import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
// icons
import LightBulbIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/Lightbulb';

export const ColStyled = styled(Col)`
  display: flex;
  justify-content: center;
  height: ${rem(70)};
  margin-bottom: ${rem(15)};
`;

export const LightBulbIconStyled = styled(LightBulbIcon)`
  width: 100%;
  height: 100%;
`;

